import { render, staticRenderFns } from "./McrFormA2b.vue?vue&type=template&id=31f7d0ed"
import script from "./McrFormA2b.vue?vue&type=script&lang=js"
export * from "./McrFormA2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports